export const SEATS_AMOUNT_INPUT_CONFIG = {
  controlName: 'seats',
  placeholder: 'Кількість місць',
  maxValue: 30,
  minValue: 1,
  allowFloat: false,
  maxInputLength: 2,
  initialValue: 1,
  unit: 'шт',
};
